import { PageId } from 'page-constants'

export const enum CurrentEnvironment {
  DEV = 'dev',
  PROD = 'prod',
}

export const enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
}

export const enum MediaBreakpoint {
  MIN_PHONE = 321,
  MEDIUM_PHONE = 360,
  MAX_PHONE = 415,
  TABLET = 520,
}

export const enum StripeFieldName {
  NAME = 'name',
  NUMBER = 'cardNumber',
  EXPIRY = 'cardExpiry',
  CVC = 'cardCvc',
}

export const TERMS_OF_USE_LINK = 'https://harmonybit.com/terms-of-use/'
export const PRIVACY_POLICY_LINK = 'https://harmonybit.com/privacy-policy/'
export const ANIMATED_BG_LINK =
  'https://d1y1lcl20timxt.cloudfront.net/physarum.js'

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const NumericKeypadRegex = /([0-9]{1}|Backspace|Enter)/
export const NumericKeypadFloatRegex = /([0-9.,]{1}|Backspace|Enter)/

export const enum LoginMethod {
  EMAIL = 'email',
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}

export const enum LoginMethodRaw {
  EMAIL = 'password',
  GOOGLE = 'google.com',
  FACEBOOK = 'facebook.com',
  APPLE = 'apple.com',
}

export const LOGIN_METHOD_RAW_MAP = {
  [LoginMethodRaw.EMAIL]: LoginMethod.EMAIL,
  [LoginMethodRaw.GOOGLE]: LoginMethod.GOOGLE,
  [LoginMethodRaw.FACEBOOK]: LoginMethod.FACEBOOK,
  [LoginMethodRaw.APPLE]: LoginMethod.APPLE,
}

export const enum Color {
  PRIMARY = '#58fe1d',
  ERROR = '#ff7076',
  WHITE = '#fff',
  ORANGE = '#ff8800',
  DARK = '#13182A',
  LIGHT = '#c0c1ca',
  DISABLED = '#898e97',
  GRADIENT = 'linear-gradient(135deg, #41bfe1 0%, #6c49e7 49.75%, #a936e8 100%)',
}

export const enum BodyBackgroundColor {
  PRIMARY = '#101B41',
  LIGHT_GRADIENT = 'linear-gradient(180deg, #722ace 0%, #1f107d 47.4%, #69b7ff 100%)',
  DARK_GRADIENT = 'linear-gradient(180deg, #141931 34.38%, #1d107d 70.83%, #69b7ff 100%)',
}

export const enum TimeInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export const enum AppWithInAppBrowser {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
}

export const enum UserAgent {
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  OTHER = 'other',
}

export const enum Cohort {
  VARIANT_ONE = 'mb_intro',
  VARIANT_TWO = 'mb_quiz',
}

export const enum Optimize {
  FIRST_EXP,
  SECOND_EXP,
  THIRD_EXP,
  FOURTH_EXP,
}

export const enum PagePath {
  LOCALHOST = 'localhost',
  CHECKOUT = 'checkout',
}

export const enum SubscriptionListType {
  PURCHASE = 'purchase',
  CANCEL_OFFER = 'cancel',
}

export const enum OptionValue {
  NOT_AT_ALL = 'not_at_all',
  OCCASIONALLY = 'occasionally',
  OFTEN = 'often',
  VERY_MUCH_SO = 'very_much_so',
}

export const enum UserGoal {
  RELIEVE_STRESS_AND_ANXIETY = 'relieve_stress_and_anxiety',
  BOOST_MOOD = 'boost_mood',
  GET_RID_OF_BRAIN_FOG = 'get_rid_of_brain_fog',
  ALL_THAT_WAS_MENTIONED = 'all_that_was_mentioned',
}

export const enum StressLevel {
  BLUE_LEVEL = 1,
  ORANGE_LEVEL = 4,
  RED_LEVEL = 5,
}

export const enum StressValue {
  LOW = 10,
  MODERATE = 20,
  SEVERE = 35,
}

export const STRESS_SCORE_TEXT_MAP = {
  [StressValue.LOW]: {
    stressTextKey: 'result.stressScore.low',
  },
  [StressValue.MODERATE]: {
    stressTextKey: 'result.stressScore.moderate',
  },
  [StressValue.SEVERE]: {
    stressTextKey: 'result.stressScore.severe',
  },
}

export const APP_NAME = 'mood'
export const CENTS_IN_DOLLAR = 100
export const INITIAL_PRICE = 0
export const DATES_NUMBER_FOR_ANIMATION = 8
export const CUSTOM_TOKEN_LOCAL_STORAGE_KEY = 'custom_token'
export const DEFAULT_CURRENCY = 'usd'
export const PAGE_TRANSITION_DELAY = 500
export const TEST_ENV_QUERY_PARAM = 'is_test_environment'
export const LANG_QUERY_PARAM = 'lang'
export const INITIAL_LANGUAGE = 'en'
export const NO_TEST_OPTIMIZE_VARIANT = 'no_test'
export const EXPERIMENT_ID_NOT_SET = 'experiment_id_not_set'
export const NO_AB_SEGMENT_NAME = 'no_name'

export const SUPPORTED_LOCALES: string[] = ['en']

export const NON_ANIMATED_PAGES: string[] = [
  PageId.RESULT,
  PageId.PURCHASE,
  PageId.DOWNLOAD,
]

export const enum ScreenName {
  ONBOARDING = 'onboarding',
  CANCEL_OFFER = 'cancel_offer',
  CANCEL_OFFER_MEALPLAN = 'cancel_offer_mealplan',
  EMAIL_OFFER = 'email_offer',
  UPSALE_SCREEN = 'upsale_screen',
}

export const BACKGROUND_COLOR_MAP: Record<Cohort, string> = {
  [Cohort.VARIANT_ONE]: BodyBackgroundColor.PRIMARY,
  [Cohort.VARIANT_TWO]: BodyBackgroundColor.LIGHT_GRADIENT,
}
